import { cloneDeep } from "lodash";
import { atom, selector } from "recoil";
import { authState, permissionState } from "../api/state/AuthState";
import Login from "../app/guest/Login";
import ForgotPassword from "../app/guest/ForgotPassword";
import ChangePassword from "../app/guest/ChangePassword";
// import Home from "../app/auth/Home";
import Users from "../app/auth/users"
import Roles from "../app/auth/roles"
import Permissions from "../app/auth/permissions"
import NonAuthLayout from "../components/NonAuthLayout";
import Events from "../app/auth/events"
import ErrorLogs from "../app/auth/errorLogs"
import AgeCategories from "../app/auth/ageCategories"
import RaceKits from "../app/auth/raceKits"
import Races from "../app/auth/races"
import TeeIssues from "../app/auth/teeIssues"
import Tees from "../app/auth/tees"
import TeeSizes from "../app/auth/teeSizes"
import TeeTypes from "../app/auth/teeTypes"
import Home from "../app/auth/Home";
import Timing from "../app/guest/Timing";
import RaceKitStatus from "../app/guest/RaceKitStatus";
import Faq from "../app/guest/Faq";
import Diagnostics from "../app/auth/diagnostics"
import LapStart from "../app/auth/lapstart"


// import HorizontalLayout from "../components/HorizontalLayout";
// import GuestHome from "../app/guest/Home";


const navigation = [
    {
        name: 'Login',
        icon: 'bx bx-lock',
        link: '/login',
        defaultRoute: true,
        component: Login,
        layout: NonAuthLayout,
        middleware: 'guest',
        hidden: true,
        children: [],
    },
    {
        name: 'Forgot Password',
        icon: 'bx bx-lock',
        link: '/forgot-password',
        component: ForgotPassword,
        layout: NonAuthLayout,
        middleware: 'guest',
        hidden: true,
        children: [],
    },
    {
        name: 'Change Password',
        icon: 'bx bx-lock',
        link: '/change-password',
        component: ChangePassword,
        layout: NonAuthLayout,
        middleware: 'guest',
        hidden: true,
        children: [],
    },
    {
        name: 'Results',
        icon: 'bx bx-lock',
        link: '/results',
        component: Timing,
        layout: NonAuthLayout,
        hidden: true,
        children: [],
    },
    {
        name: 'Race Kit Status',
        icon: 'bx bx-lock',
        link: '/race-kit-status',
        component: RaceKitStatus,
        layout: NonAuthLayout,
        hidden: true,
        children: [],
    },
    {
        // No middleware, so expo volunteers reach it without an account and
        // signed-in staff are not bounced off it. 'guest' would mean
        // logged-out only, which is the opposite of what this needs.
        name: 'FAQ',
        icon: 'bx bx-help-circle',
        link: '/faq',
        component: Faq,
        layout: NonAuthLayout,
        hidden: true,
        children: [],
    },
    {
        name: 'Home',
        icon: 'mdi mdi-monitor-dashboard',
        link: '/home',
        defaultRoute: true,
        component: Home,
        middleware: 'auth',
        children: [],
    },
	
    {
        name: 'Main',
        icon: "bx bx-group",
        children: [
            { // RaceKit Route Begin
                name: 'Race Kit',
                icon: 'mdi mdi-package-variant',
                link: '/raceKits',
                component: RaceKits,
                middleware: 'auth',
                permission: 'read-raceKits',
                children: [],
            }, // RaceKit Route End
            { // TeeIssue Route Begin
                name: 'Souvenir Shop',
                icon: 'mdi mdi-cart-outline',
                link: '/souvenirShop',
                component: TeeIssues,
                middleware: 'auth',
                permission: 'read-teeIssues',
                children: [],
            }, // TeeIssue Route End
            { // Tee Route Begin
                name: 'Tee Inventory',
                icon: 'mdi mdi-tshirt-crew-outline',
                link: '/teeInventory',
                component: Tees,
                middleware: 'auth',
                permission: 'read-tees',
                children: [],
            }, // Tee Route End
            { // Diagnostics Route Begin
                name: 'Diagnostics',
                icon: 'mdi mdi-clipboard-pulse-outline',
                link: '/diagnostics',
                component: Diagnostics,
                middleware: 'auth',
                permission: 'manage-timings',
                children: [],
            }, // Diagnostics Route End
        ]
    },
    {
        name: 'Master',
        icon: "bx bx-group",
        children: [
            { // TeeType Route Begin
                name: 'Tee Type',
                icon: 'mdi mdi-tshirt-v',
                link: '/teeTypes',
                component: TeeTypes,
                middleware: 'auth',
                permission: 'read-teeTypes',
                children: [],
            }, // TeeType Route End
            { // TeeSize Route Begin
                name: 'Tee Size',
                icon: 'mdi mdi-alpha-t-circle-outline',
                link: '/teeSizes',
                component: TeeSizes,
                middleware: 'auth',
                permission: 'read-teeSizes',
                children: [],
            }, // TeeSize Route End
            { // Race Route Begin
                name: 'Race',
                icon: 'mdi mdi-run',
                link: '/races',
                component: Races,
                middleware: 'auth',
                permission: 'read-races',
                children: [],
            }, // Race Route End
            { // AgeCategory Route Begin
                name: 'Age Category',
                icon: 'mdi mdi-chevron-triple-up',
                link: '/ageCategories',
                component: AgeCategories,
                middleware: 'auth',
                permission: 'read-ageCategories',
                children: [],
            }, // AgeCategory Route End
            { // Event Route Begin
                name: 'Event',
                icon: 'mdi mdi-calendar',
                link: '/events',
                component: Events,
                middleware: 'auth',
                permission: 'read-events',
                children: [],
            }, // Event Route End
            { // LapStart Route Begin
                name: 'LapStart Sync',
                icon: 'mdi mdi-cloud-sync-outline',
                link: '/lapstart',
                component: LapStart,
                middleware: 'auth',
                permission: 'read-lapstart',
                children: [],
            }, // LapStart Route End
        ]
    },
	{ // ErrorLog Route Begin
		name: 'Error Log',
		icon: 'mdi mdi-monitor-dashboard',
		link: '/errorLogs',
		component: ErrorLogs,
		middleware: 'auth',
		permission: 'read-errorLogs',
		children: [],
	}, // ErrorLog Route End
	// Navigations
    
    {
        name: 'ACL',
        icon: "bx bx-group",
        children: [
            {
                name: 'Users',
                icon: 'bx bx-group',
                link: '/acl/users',
                component: Users,
                middleware: 'auth',
                permission: 'read-users',
                children: []
            },
            {
                name: 'Roles',
                icon: 'mdi mdi-account-key-outline',
                link: '/acl/roles',
                component: Roles,
                middleware: 'auth',
                permission: 'read-roles',
                children: []
            },
            {
                name: 'Permissions',
                icon: 'bx bx-lock-open-alt',
                link: '/acl/permissions',
                component: Permissions,
                middleware: 'auth',
                permission: 'read-permissions',
                children: []
            },
        ]
    },
];


const megaMenu = [
    // {
    //     name: 'UI Components',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Lightbox',
    //             link: '/lightbox',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Range Slider',
    //             link: '/rangeslider',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // },
    // {
    //     name: 'Applications',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Ecommerce',
    //             link: '/ecommerce',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Calendar',
    //             link: '/calendar',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // },
    // {
    //     name: 'Extra Pages',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Maintenance',
    //             link: '/maintenance',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Coming Soon',
    //             link: '/comingsoon',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // }
]

const rawNavigationState = atom({
    key: 'rawNavigationState',
    default: navigation,
});


const rawMegaMenuState = atom({
    key: 'rawMegaMenuState',
    default: megaMenu,
});





export const navigationState = selector({
    key: 'navigationState',
    get: ({ get }) => {
        let tempNavigation = cloneDeep(get(rawNavigationState))
        const isAuth = get(authState)
        const permissions = get(permissionState)
        const parseModule = (nav) => {
            let returnVal = null
            if(nav.children.length > 0){
                if((isAuth && nav.middleware === "auth" && (!nav.permission || permissions.includes(nav.permission))) || (!isAuth && (nav.middleware === "guest" )) || !nav.middleware){
                    let tempChildren = []
                    nav.children.forEach((child)=>{
                        let temp = parseModule(child)
                        if(temp){
                            tempChildren = [...tempChildren, temp]
                        }
                    })
                    returnVal = {...nav, children: tempChildren}
                }
            } else {
                if((isAuth && nav.middleware === "auth" && (!nav.permission || permissions.includes(nav.permission))) || (!isAuth && (nav.middleware === "guest")) || !nav.middleware){
                    returnVal = nav
                }
            }
            return returnVal
        }
        // Remove Nav Items based on auth and permissions
        tempNavigation = tempNavigation.map((header)=>parseModule(header)).filter(n=>n!==null);
        // Remove Empty Parents
        const filterChildren = (nav) => {
            if(nav.children.filter(c=>c.children.length > 0).length > 0){
                nav.children = nav.children.map((child)=>{
                    child = filterChildren(child)
                    return child
                })
            } else {
                nav.children = nav.children.filter(c=>(c.children.length > 0 || c.component))
            }
            return nav
        }
        tempNavigation = tempNavigation.map((header)=>filterChildren(header));
        // Remove Empty Modules
        tempNavigation = tempNavigation.filter(header=>(header.children.length > 0 || header.component))
        return tempNavigation;
    }
})

export const megaMenuState = selector({
    key: 'megaMenuState',
    get: ({ get }) => {
        let tempMegaMenu = cloneDeep(get(rawMegaMenuState))
        const isAuth = get(authState)
        const permissions = get(permissionState)
        tempMegaMenu = tempMegaMenu.map((header)=>{
            header.children = header.children.filter(c=>(isAuth && c.middleware === "auth" && (!c.permission || permissions.includes(c.permission))) || (!isAuth && (c.middleware === "guest")) || !c.middleware)
            return header
        }).filter(header=>header.children.length > 0);
        return tempMegaMenu;
    }
})
